export const INFINITE = 9999;
